import { Neutral, Red } from 'glints-aries/es/@next/utilities/colors';
import { space8 } from 'glints-aries/es/@next/utilities/spacing';
import styled from 'styled-components';

export const FormContentStyles = {
  Asterisk: styled.span`
    ::before {
      color: ${Red.B93};
      content: '*';
    }
  `,
  ImageUploadButton: styled.button`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: ${space8};
    border: 1px dashed ${Neutral.B68};
    background-color: ${Neutral.B99};
    width: 80px;
    height: 80px;
    align-items: center;
    justify-content: center;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    &[data-image-selected='true'] {
      border-style: solid;
    }

    &[data-ignore-padding='true'] {
      padding: 0;
    }

    .remove-file-icon {
      position: absolute;
      bottom: 4px;
      left: 4px;
      border-radius: 100%;
      border: 1px solid ${Neutral.B68};
      background-color: ${Neutral.B100};
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    &[data-error='true'] {
      border-color: ${Red.B93};
      color: ${Red.B93};
      svg {
        fill: ${Red.B93};
      }
    }
  `,
};
